export const CDN_URL="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const LOGO_URL="https://market-resized.envatousercontent.com/previews/files/108993892/Preview.jpg?w=590&h=590&cf_fit=crop&crop=top&format=auto&q=85&s=892689c13d3946967679c17ab45c24c5fa4501e0d351ed955341a77e5b890b42";




// export const FOODFIRE_API_URL = "https://namastedev.com/api/v1/listRestaurants";

export const Menu_API ="https://corsproxy.io/https://namastedev.com/api/v1/listRestaurantMenu/";

    
export const Restaurant_API="https://corsproxy.io/https://namastedev.com/api/v1/listRestaurants?lat=17.385044&lng=78.486671";